import { FileReference } from '@kaizenplatform/belfast-entity';
import { DynamicSchemaFieldKey } from '@kaizenplatform/hugot-entity';
import { castDraft, produce } from 'immer';

import State from '../core/State';
import { IssueForProjectFragment, ProjectDetailsForShowFragment } from '../generated/graphql';
import { ProjectForBrief } from '../graphql/project';
import initialState from '../initialState';
import { IssueCommentForProjectFragment } from './../generated/graphql';

export const startFetchingProject = () => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    projectFetching: state.project.projectFetching + 1,
  },
});

export const finishFetchingProject = (project: ProjectForBrief & ProjectDetailsForShowFragment) => (
  state: State,
): State => ({
  ...state,
  project: {
    ...state.project,
    project,
    projectFetching: state.project.projectFetching - 1,
  },
});

export const startFetchingAssetFiles = () => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    filesFetching: state.project.filesFetching + 1,
  },
});

export const finishFetchingAssetFiles = (files: ReadonlyArray<FileReference>) => (state: State): State => {
  return produce(state, (draft) => {
    draft.project.assetFiles = castDraft(files);
    draft.project.filesFetching = draft.project.filesFetching - 1;
  });
};

export const startFetchingBriefFiles = () => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    filesFetching: state.project.filesFetching + 1,
  },
});

export const finishFetchingBriefFiles = (files: Map<DynamicSchemaFieldKey, FileReference[]>) => (
  state: State,
): State => ({
  ...state,
  project: {
    ...state.project,
    briefFiles: files,
    filesFetching: state.project.filesFetching - 1,
  },
});

export const disposeProjectAndCreations = () => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    project: initialState.project.project,
  },
});

export const setProjectIssue = (projectIssue: IssueForProjectFragment) => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    project: {
      ...state.project.project!,
      issue: projectIssue,
    },
  },
});

export const setProjectIssueComment = (projectIssueComment: IssueCommentForProjectFragment) => (
  state: State,
): State => {
  const comments = [...state.project.project!.issue!.comments, projectIssueComment];
  return {
    ...state,
    project: {
      ...state.project,
      project: {
        ...state.project.project!,
        issue: {
          ...state.project.project!.issue!,
          comments,
        },
      },
    },
  };
};

export const updateProjectIssueComment = (projectIssueComment: IssueCommentForProjectFragment) => (
  state: State,
): State => {
  const comments = Array<IssueCommentForProjectFragment>();
  (state.project?.project?.issue?.comments || []).forEach((c) => {
    comments.push(c.id == projectIssueComment.id ? projectIssueComment : c);
  });
  return {
    ...state,
    project: {
      ...state.project,
      project: {
        ...state.project.project!,
        issue: {
          ...state.project.project!.issue!,
          comments,
        },
      },
    },
  };
};

export const deleteProjectIssueComment = (commentId: string) => (state: State): State => {
  const comments = Array<IssueCommentForProjectFragment>();
  (state.project?.project?.issue?.comments || []).forEach((c) => {
    if (c.id !== commentId) {
      comments.push(c);
    }
  });
  return {
    ...state,
    project: {
      ...state.project,
      project: {
        ...state.project.project!,
        issue: {
          ...state.project.project!.issue!,
          comments,
        },
      },
    },
  };
};
